/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "../../../../../components/FormField";


function ResetPasswordForm({formData}) {

    const {formField, values, errors, touched} = formData;
    const {email, password, password_confirmation} = formField;
    const {
        email: emailV,
        password: passwordV,
        password_confirmation: passwordConfirmationV
    } = values;

    return (
        <MDBox>
            <MDBox mb={3}>
                <FormField
                    type={email.type}
                    label={email.label}
                    name={email.name}
                    value={emailV}
                    placeholder={email.placeholder}
                    error={errors.email && touched.email}
                    success={emailV.length > 0 && !errors.email}
                />
            </MDBox>
            <MDBox mb={3}>
                <FormField
                    type={password.type}
                    label={password.label}
                    name={password.name}
                    value={passwordV}
                    placeholder={password.placeholder}
                    error={errors?.password && touched?.password}
                    success={passwordV?.length > 0 && !errors?.password}
                />
            </MDBox>
            <MDBox mb={3}>
                <FormField
                    type={password_confirmation.type}
                    label={password_confirmation.label}
                    name={password_confirmation.name}
                    value={passwordConfirmationV}
                    placeholder={password_confirmation.placeholder}
                    error={errors?.password_confirmation && touched?.password_confirmation}
                    success={passwordConfirmationV?.length > 0 && !errors?.password_confirmation}
                />
            </MDBox>
        </MDBox>
    );
}

export default ResetPasswordForm;
